import {createActionCreator} from '../common/actions';
import {AlbumListFilter} from './reducer';

export const AlbumListFilterSet = createActionCreator<AlbumListFilter>('ALBUM_LIST_FILTER_SET');
